var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: `${_vm.form.id ? "编辑" : "添加"}${_vm.title}`,
        width: 700,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            labelCol: { span: 2 },
            wrapperCol: { span: 22 },
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "标题", prop: "title" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入视频标题" },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "视频" } },
            [
              _c(
                "a-upload-dragger",
                {
                  attrs: {
                    disabled: false,
                    accept: ".mp4",
                    name: "file",
                    "file-list": _vm.fileList,
                    multiple: false,
                    action: _vm.uploadAction,
                    headers: _vm.tokenHeader,
                  },
                  on: { change: _vm.handleChange },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "10px" } },
                    [
                      _c("a-icon", {
                        style: { fontSize: "30px", color: "#737373" },
                        attrs: { type: "plus-circle" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "ant-upload-text",
                      staticStyle: { "font-weight": "bold", color: "#737373" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.form.id ? "编辑" : "添加") +
                          _vm._s(_vm.title) +
                          "文件\n        "
                      ),
                    ]
                  ),
                  _c("p", { staticClass: "ant-upload-hint" }, [
                    _vm._v("(仅支持.mp4格式文件)"),
                  ]),
                ]
              ),
              !this.fileList.length && _vm.form.url
                ? _c(
                    "a",
                    { attrs: { href: _vm.getStoreFileUrl(_vm.form.url) } },
                    [_vm._v("\n        " + _vm._s(_vm.title) + "地址\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            {
              staticClass: "coverUrl-item",
              attrs: { label: "封面", prop: "coverUrl" },
            },
            [
              _c(
                "div",
                { staticClass: "flex-align-center" },
                [
                  _c("j-image-upload", {
                    ref: "coverRef",
                    attrs: { accept: ".png,.jpg,.jpeg", bizPath: "dayOath" },
                    model: {
                      value: _vm.form.coverUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "coverUrl", $$v)
                      },
                      expression: "form.coverUrl",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }